import { createTheme  } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#1E1E1E',
    },
    secondary: {
      main: '#CD909D',
    },
  },
  shape: {
    borderRadius: 25,
  },
});